import { render, staticRenderFns } from "./LollipopChar_new.vue?vue&type=template&id=67de0a66&scoped=true"
import script from "./LollipopChar_new.vue?vue&type=script&lang=js"
export * from "./LollipopChar_new.vue?vue&type=script&lang=js"
import style0 from "./LollipopChar_new.vue?vue&type=style&index=0&id=67de0a66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67de0a66",
  null
  
)

export default component.exports